// Amplitude in the browser: page views and what happens on the form before the bet
// reaches the server. Everything after that (game created, payment, result, payout,
// SMS) is tracked by the backend (backend/src/services/analytics.js) on the same player.
import * as amplitude from "@amplitude/analytics-browser";

const API_KEY = `${process.env.REACT_APP_AMPLITUDE_API_KEY || ""}`.trim();
const COUNTRY_CODE = "243";

let started = false;

export function initAnalytics() {
  if (!API_KEY || started) return;
  started = true;
  amplitude.init(API_KEY, {
    serverZone: `${process.env.REACT_APP_AMPLITUDE_SERVER_ZONE || "US"}`.toUpperCase() === "EU" ? "EU" : "US",
    autocapture: {
      attribution: true, // utm_* and referrer of the first visit
      pageViews: true,
      sessions: true,
      formInteractions: false, // the form holds the phone number
      fileDownloads: false,
      elementInteractions: false,
    },
  });
}

// Same as the server's normalizeMsisdnForDb for the numbers the form accepts.
function normalizePhone(value) {
  let digits = `${value || ""}`.replace(/\D/g, "");
  if (digits.startsWith("00")) digits = digits.slice(2);
  if (digits.startsWith(COUNTRY_CODE)) return digits;
  if (digits.length === 10 && digits.startsWith("0")) return `${COUNTRY_CODE}${digits.slice(1)}`;
  if (digits.length === 9) return `${COUNTRY_CODE}${digits}`;
  return digits;
}

// Links this browser to the player: the user id is the SHA-256 of the number, as on
// the server. The number itself is set as a user property by the server only.
export async function identifyPlayer(phone) {
  if (!started || !window.crypto?.subtle) return;
  const msisdn = normalizePhone(phone);
  if (!msisdn) return;
  try {
    const hash = await window.crypto.subtle.digest("SHA-256", new TextEncoder().encode(msisdn));
    const userId = Array.from(new Uint8Array(hash), (b) => b.toString(16).padStart(2, "0")).join("");
    amplitude.setUserId(userId);
  } catch (_) {
    // Analytics must never block a bet.
  }
}

export function track(eventType, properties = {}) {
  if (!started) return;
  amplitude.track(eventType, { channel: "WEB", ...properties });
}
